module.exports = __webpack_public_path__ + "videos/6.c29e080.mp4";